<form class="form-inline" novalidate>
    <div class="form-group">
        <label for="searchString">
            {{label}}
        </label>
        <input PgsInputContratista type="text" class="form-control form-control-sm mx-3" [class.is-invalid]="searchFailed" id="searchString"
            [ngbTypeahead]="search" (selectItem)="selectResult($event)" [inputFormatter]="formatter" placeholder="{{placeholder}}"
            [resultTemplate]="rt" (keydown.enter)="$event.preventDefault()" (input)="searchString = $event.target.value" [value]="searchString" >
        <button *ngIf="showSearchButton" type="button" (click)="$event.preventDefault(); searchByButton();" class="btn btn-secondary btn-sm">
            <i class="fa fa-search"></i> Consultar
        </button>
        <i *ngIf="loading" class="ml-1 fa fa-spinner fa-spin fa-fw"></i>
        <span class="mt-1 invalid-feedback" *ngIf="searchFailed">{{errorMsg}}</span>
    </div>
</form>

<ng-template #rt let-r="result" let-t="term">
    <div class="list-group">
        <a class="list-group active">
            <ngb-highlight result="{{r.title}}" term="{{t}}"></ngb-highlight>
            <small>{{r.subtitle}}</small>
        </a>
    </div>
</ng-template>
